export default function (key, defaultValue = null) {
    if (process.env[key]) {
        return process.env[key];
    }
    return defaultValue;
};


// WEBPACK FOOTER //
// ./src/services/env.js